import React, { useCallback, useMemo, useState } from 'react'
import { Outlet } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { Box, useMediaQuery, useTheme } from '@mui/material'
import circlesOrbitColorPalette from 'common/ui/circlesColorTheme'

import MobileAppBar from './Mobile/MobileAppBar'
import SideNavBar from './Web/Navbar'

import 'react-toastify/dist/ReactToastify.css'

const Layout = () => {
  const theme = useTheme()
  // remove Layout, set topnav
  const mobileBreakpt = useMediaQuery(theme.breakpoints.down('xs'))
  // collapse Layout
  const tabletBreakpt = useMediaQuery(theme.breakpoints.between('sm', 'md'))
  const desktopBreakpt = useMediaQuery(theme.breakpoints.up('md'))

  const [collapsedSideBar, toggleCollapsedSideBar] = useState(false)
  const [showSideBar, toggleShowSideBar] = useState(true)
  const [mobileAppBar, toggleMobileAppBar] = useState(false)

  useMemo(
    useCallback(() => {
      toggleShowSideBar(!mobileBreakpt)
      toggleMobileAppBar(mobileBreakpt)
    }),
    [mobileBreakpt]
  )

  useMemo(
    useCallback(() => {
      toggleCollapsedSideBar(!tabletBreakpt)
    }),
    [tabletBreakpt, desktopBreakpt]
  )

  return (
    <Box sx={{ width: '100vw', height: '100vh' }}>
      {/* Mobile App Bar at sm-breakpoints */}
      {mobileAppBar && <MobileAppBar />}

      <Box
        display='flex'
        flexDirection='row'
        justifyContent='flex-start'
        height='100vh'
      >
        {showSideBar && (
          <SideNavBar
            hideToggle={!mobileBreakpt}
            collapsedSideBar={collapsedSideBar}
            toggleCollapsedSideBar={toggleCollapsedSideBar}
          />
        )}
        <ToastContainer
          position='bottom-center'
          autoClose={5000}
          hideProgressBar
        />
        <Box
          width={
            mobileAppBar
              ? '100vw'
              : showSideBar && collapsedSideBar
              ? 'calc(100vw - 250px)'
              : 'calc(100vw - 100px)'
          }
          style={{
            padding: 25,
            overflowY: 'scroll',
            backgroundColor: circlesOrbitColorPalette.neutrals.background2
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  )
}

export default Layout
